import Validator from './modules/validator';

const Suba = {
  Validator,
};

export default Suba;



/** WEBPACK FOOTER **
 ** ./src/Suba.js
 **/